<template lang="pug">
    .flex(class="flex-col gap-5 w-full 1024:w-400")
        app-text-block
            template(v-if="!recipient_exists")
                p {{TEXT.IF_WINNER}}
            template(v-else)
                app-greeting
                p {{ precheckMessage || TEXT.IS_WINNER }}

        template(v-if="!recipient_exists")
            .flex.flex-col.w-250
                label(for="phone" class="text-sm text-center mb-2") {{FORM_LABELS.enter_phone_number}}
                input(
                    type="text" 
                    id="phone" 
                    v-model="phone" 
                    v-mask="'+#(###) ###-##-##'" 
                    placeholder="+7" 
                    class="pl-5 pr-5 bg-white h-10 rounded-full input-shadow mb-5"
                    @keyup.enter="onPhone($data)"
                )
                app-button(:loading="checking" @click="onPhone($data)")
                    template {{ FORM_BUTTONS.check }}
            
        transition(name='fade' mode='out-in')
            template(v-if="recipient_exists")
                section.w-250
                    .flex.flex-col.mb-5
                        label(for="sms-code" class="text-sm text-center mb-2") {{FORM_LABELS.sms_code}}
                        input(
                            id="sms-code" 
                            v-model="password"
                            class="pl-5 pr-5 bg-white h-10 rounded-full input-shadow text-center"
                            @keyup.enter="onLogin($data)"
                        )
                        p.sms-resend(v-if="resendLimited && resendLeft > 0")
                            | Код можно отправить не больше 3 раз подряд.
                            br
                            | Следующая отправка через {{ resendClock }}
                        p.sms-resend(v-else-if="resendLeft > 0") Отправить код еще раз через {{ resendClock }}
                        button.sms-resend.sms-resend-active(
                            v-else
                            type="button"
                            :class="{ 'sms-resend-wait': resending }"
                            @click="onResend"
                        ) Отправить код еще раз
                    app-button.w-full(:loading="loggingIn" @click="onLogin($data)")
                        template {{ FORM_BUTTONS.enter }}
                    
        template(v-if="recipient_exists === 0")
            app-notification.mt-5
                p {{TEXT.NOT_A_WINNER}}
</template>

<script>
//Components
import Notification from '@/components/common/notifications'
import TextBlock from '@/components/common/text-block'
import Greeting from '@/components/common/greeting'
import Button from '@/components/common/button'
//Store
import { AuthorizationNameSpace, AuthorizationActionTypes } from '@/store/authorization/types';
//Config
import { FORM_LABELS, FORM_BUTTONS } from '@/configs/forms'
import { TEXT } from '@/configs/text'
//Helpers
import { notifyError } from '@/helpers/notifications';

export default {
    name: "login-form",
    components: {
        'app-notification': Notification,
        'app-text-block': TextBlock,
        'app-greeting': Greeting,
        'app-button': Button,
    },
    data() {
        return {
            phone: '',
            password: '',
            recipient_exists: '',
            precheckMessage: '',
            checking: false,
            loggingIn: false,
            resendLeft: 0,
            resendTimer: null,
            resending: false,
            resendLimited: false,
        }
    },
    computed: {
        FORM_LABELS() {
            return FORM_LABELS
        },
        FORM_BUTTONS() {
            return FORM_BUTTONS
        },
        TEXT() {
            return TEXT
        },
        resendClock() {
            const minutes = Math.floor(this.resendLeft / 60)
            const seconds = String(this.resendLeft % 60).padStart(2, '0')
            return `${minutes}:${seconds}`
        },
    },
    beforeDestroy() {
        this.clearResendTimer()
    },
    methods: {
        notifyError({title}) {
            return notifyError({title})
        },
        async onPhone({phone}) {
            if (this.checking) {
                return
            }
            const phone_value = phone.replace(/\D+/g, '')
            
            if (phone_value.length === 11) {
                this.checking = true
                try {
                    await this.onPrecheck({phone: phone_value})
                } finally {
                    this.checking = false
                }
            } else {
                this.notifyError({title: 'Неверный формат номера телефона'})
            }
        },
        clearResendTimer() {
            if (this.resendTimer) {
                clearInterval(this.resendTimer)
                this.resendTimer = null
            }
        },
        startResendCountdown(seconds, limited = false) {
            this.clearResendTimer()
            this.resendLimited = limited
            this.resendLeft = seconds
            if (!seconds) {
                this.resendLimited = false
                return
            }
            this.resendTimer = setInterval(() => {
                if (this.resendLeft <= 1) {
                    this.resendLeft = 0
                    this.resendLimited = false
                    this.clearResendTimer()
                    return
                }
                this.resendLeft -= 1
            }, 1000)
        },
        async onPrecheck({ phone, resend = false }) {
            const params = resend ? { phone, resend: 1 } : { phone }
            await this.$store.dispatch(`${AuthorizationNameSpace}/${AuthorizationActionTypes.Precheck}`, { params })
                .then((response) => {
                    const data = response && response.data && response.data.data
                    if (data && data.recipient_exists > 0) {
                        this.recipient_exists = data.recipient_exists
                        if (!resend || data.sms_sent || data.sms_limited) {
                            this.precheckMessage = response.data.message || ''
                        }
                        if (data.sms_limited) {
                            this.startResendCountdown(data.retry_after || 15 * 60, true)
                        } else if (data.retry_after > 0) {
                            this.startResendCountdown(data.retry_after)
                        } else if (data.sms_sent) {
                            this.startResendCountdown(45)
                        } else {
                            this.clearResendTimer()
                            this.resendLeft = 0
                            this.resendLimited = false
                        }
                    } else if (data && data.recipient_exists === 0) {
                        this.recipient_exists = 0
                        this.precheckMessage = ''
                        this.clearResendTimer()
                        this.resendLeft = 0
                        this.resendLimited = false
                    }
                })
        },
        async onResend() {
            if (this.resendLeft > 0 || this.resending || this.checking) {
                return
            }
            const phone_value = this.phone.replace(/\D+/g, '')
            if (phone_value.length !== 11) {
                return
            }
            this.resending = true
            try {
                await this.onPrecheck({ phone: phone_value, resend: true })
            } finally {
                this.resending = false
            }
        },
        async onLogin({ phone, password }) {
            if (this.loggingIn) {
                return
            }
            if (this.password) {
                this.loggingIn = true
                try {
                    await this.$store.dispatch(`${AuthorizationNameSpace}/${AuthorizationActionTypes.Login}`, { phone: phone.replace(/\D+/g, ''), password })
                    this.$router.push('account')
                } finally {
                    this.loggingIn = false
                }
            } else {
                this.notifyError({title: 'Введите код'})
            }
        },      
    },
}
</script>

<style lang="sass" scoped>
.sms-resend
    margin-top: 12px
    text-align: center
    font-size: 14px
    line-height: 1.3
    color: #b0b0b0

.sms-resend-active
    display: block
    width: 100%
    padding: 0
    border: 0
    background: none
    color: #b0b0b0
    text-decoration: underline
    cursor: pointer

.sms-resend-wait
    cursor: wait
    opacity: 0.6
</style>